import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCambioCategoriaCaravana = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'cambio_categoria_caravana',
        name: 'Cambio de Categoria por Caravana',
        component: ViewCambioCategoriaCaravana,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
